import { useSelectedYear } from "$/lib/hooks/useSelectedYear";
import { cn } from "$/lib/utils/functions/misc.functions";

import ProfileInfoProgress from "./ProfileInfoProgress";

interface Props {
  containerClassName?: string;
  titleClassName?: string;
  textClassName?: string;
  progressClassName?: string;
  strokeWidth?: number;
}

const ProfileCompletionStatus = ({
  containerClassName,
  titleClassName,
  textClassName,
  progressClassName,
  strokeWidth,
}: Props) => {
  const { sessionStorageYearValue } = useSelectedYear();

  return (
    <ProfileInfoProgress
      className={cn(`gap-6 whitespace-nowrap`, containerClassName)}
      progressClassName={progressClassName}
    >
      <div>
        <h3 className={cn(`text-sm font-semibold`, titleClassName)}>
          Complétude du profil
        </h3>
        <p className={cn(`ml-auto w-fit text-xs text-textInfo`, textClassName)}>
          Estimation {sessionStorageYearValue}
        </p>
      </div>
    </ProfileInfoProgress>
  );
};

export default ProfileCompletionStatus;
